"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EPointsContextProvider = exports.useEPoints = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _TokenProvider = require("../../common/TokenProvider");
var _agent = require("@deosite/agent");
var _LanguageProvider = require("../../common/LanguageProvider");
var _CartProvider = require("../CartProvider");
var _MessageHandlerProvider = require("../../common/MessageHandlerProvider");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _mapEPoints = _interopRequireDefault(require("@deosite/helpers/mapEPoints"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EPointsContext = /*#__PURE__*/_react["default"].createContext();
var defaultEPoints = {
  availablePoints: null,
  lockedPoints: null,
  pointsSavedInCart: null,
  history: []
};
var defaultPending = {
  ePointsData: false,
  pointsToEarn: false
};
var EPointsContextProvider = function EPointsContextProvider(_ref) {
  var children = _ref.children;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useCart = (0, _CartProvider.useCart)(),
    handleResponseErrors = _useCart.handleResponseErrors,
    cart = _useCart.cart;
  var _useState = (0, _react.useState)(_objectSpread({}, defaultPending)),
    isPending = _useState[0],
    setPending = _useState[1];
  var _useState2 = (0, _react.useState)(_objectSpread({}, defaultEPoints)),
    ePoints = _useState2[0],
    setEPoints = _useState2[1];
  var translations = {
    errorPoints: (0, _langLibrary["default"])("You don't have enough points"),
    totalPriceUnderZero: (0, _langLibrary["default"])("Too many points provided")
  };
  var getPointsSavedInCart = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _cart$totals, points;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (token) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(isPending !== null && isPending !== void 0 && isPending.pointsToEarn)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", ePoints !== null && ePoints !== void 0 && ePoints.pointsSavedInCart ? ePoints.pointsSavedInCart : undefined);
            case 4:
              setPending(_objectSpread(_objectSpread({}, isPending), {}, {
                pointsToEarn: true
              }));
              _context.prev = 5;
              points = (_cart$totals = cart.totals) === null || _cart$totals === void 0 ? void 0 : _cart$totals.ePremiaPoints;
              setEPoints(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  pointsSavedInCart: points
                });
              });
              return _context.abrupt("return", points);
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 11]]);
    }));
    return function getPointsSavedInCart() {
      return _ref2.apply(this, arguments);
    };
  }();
  var isPendingEPointsData = false;
  var getEPoints = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var ePremiaMapped;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (token) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", null);
            case 2:
              if (!isPendingEPointsData) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              if (!(isPending !== null && isPending !== void 0 && isPending.ePointsData)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", ePoints ? ePoints : null);
            case 6:
              isPendingEPointsData = true;
              setPending(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  ePointsData: true
                });
              });
              _context2.prev = 8;
              _context2.t0 = _mapEPoints["default"];
              _context2.next = 12;
              return _agent.requests.get(global.__appConfig__.ePointsAccount, false, token, language);
            case 12:
              _context2.t1 = _context2.sent;
              ePremiaMapped = (0, _context2.t0)(_context2.t1);
              setEPoints(function (prev) {
                return _objectSpread(_objectSpread({}, prev), ePremiaMapped);
              });
              return _context2.abrupt("return", ePremiaMapped);
            case 18:
              _context2.prev = 18;
              _context2.t2 = _context2["catch"](8);
            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 18]]);
    }));
    return function getEPoints() {
      return _ref3.apply(this, arguments);
    };
  }();
  var clearEPoints = function clearEPoints() {
    setEPoints(_objectSpread({}, defaultEPoints));
    setPending(_objectSpread({}, defaultPending));
  };
  var addPoints = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(points) {
      var _cart$totals2;
      var isErrorCart;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              points = parseInt(points);
              if (!(!ePoints.pointsSavedInCart && points === 0 || !token)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              if (!(points > (ePoints === null || ePoints === void 0 ? void 0 : ePoints.availablePoints))) {
                _context3.next = 6;
                break;
              }
              handleMessage(translations.errorPoints, false);
              return _context3.abrupt("return");
            case 6:
              if (!(((_cart$totals2 = cart.totals) === null || _cart$totals2 === void 0 ? void 0 : _cart$totals2.cartTotalPrice) - points / 100 < 0)) {
                _context3.next = 9;
                break;
              }
              handleMessage(translations.totalPriceUnderZero, false);
              return _context3.abrupt("return");
            case 9:
              _context3.prev = 9;
              _context3.next = 12;
              return _agent.requests.put(global.__appConfig__.ePointsAddPoints + "/".concat(points), false, token, language);
            case 12:
              //Todo po co to ? :)
              // await setPaymentWithTotals(null);

              setEPoints(_objectSpread(_objectSpread({}, ePoints), {}, {
                pointsSavedInCart: points
              }));
              _context3.next = 21;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](9);
              _context3.next = 19;
              return handleResponseErrors(_context3.t0);
            case 19:
              isErrorCart = _context3.sent;
              if (!isErrorCart) {
                handleMessage(_context3.t0);
              }
            case 21:
              return _context3.abrupt("return", points);
            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9, 15]]);
    }));
    return function addPoints(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return __jsx(EPointsContext.Provider, {
    value: {
      availablePoints: ePoints === null || ePoints === void 0 ? void 0 : ePoints.availablePoints,
      history: ePoints === null || ePoints === void 0 ? void 0 : ePoints.history,
      pointsInCart: ePoints === null || ePoints === void 0 ? void 0 : ePoints.pointsSavedInCart,
      getEPoints: getEPoints,
      addPoints: addPoints,
      getPointsSavedInCart: getPointsSavedInCart,
      clearEPoints: clearEPoints
    }
  }, children);
};
exports.EPointsContextProvider = EPointsContextProvider;
var useEPoints = function useEPoints() {
  var loadEPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useContext = (0, _react.useContext)(EPointsContext),
    getEPoints = _useContext.getEPoints,
    availablePoints = _useContext.availablePoints,
    history = _useContext.history,
    addPoints = _useContext.addPoints,
    pointsInCart = _useContext.pointsInCart,
    getPointsSavedInCart = _useContext.getPointsSavedInCart,
    clearEPoints = _useContext.clearEPoints;
  (0, _react.useEffect)(function () {
    if (loadEPoints) {
      getEPoints();
    }
  }, [loadEPoints]);
  var pointsSavedInCart = function pointsSavedInCart() {
    var loadPointsSavedInCart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    (0, _react.useEffect)(function () {
      if (!loadPointsSavedInCart) return;
      if (!pointsInCart) {
        getPointsSavedInCart();
      }
    }, [loadPointsSavedInCart]);
    return pointsInCart;
  };
  return {
    availablePoints: availablePoints,
    history: history,
    addPoints: addPoints,
    pointsSavedInCart: pointsSavedInCart,
    clearEPoints: clearEPoints
  };
};
exports.useEPoints = useEPoints;